import React from "react";
import { RightOutlined, InfoCircleFilled } from '@ant-design/icons';

// Tooltip component for info icon
function InfoTooltip({ info }) {
  const [show, setShow] = React.useState(false);
  return (
    <span style={{ position: 'relative', display: 'inline-block' }}>
      <InfoCircleFilled
        style={{ color: '#111', fontSize: 17, marginLeft: 4, cursor: 'pointer', verticalAlign: 'middle' }}
        onMouseEnter={() => setShow(true)}
        onMouseLeave={() => setShow(false)}
        onTouchStart={() => setShow(v => !v)}
      />
      {show && (
        <span style={{
          position: 'absolute',
          left: '50%',
          top: '120%',
          transform: 'translateX(-50%)',
          background: '#222',
          color: '#fff',
          padding: '7px 14px',
          borderRadius: 7,
          fontSize: 13,
          whiteSpace: 'nowrap',
          zIndex: 10,
          boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
        }}>
          {info}
        </span>
      )}
    </span>
  );
}

function formatCurrency(value) {
  if (!value) return '';
  const num = Number(String(value).replace(/[^\d.]/g, ''));
  if (isNaN(num)) return value;
  return `GHS ${num.toLocaleString()}`;
}

function formatDate(dateStr) {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return dateStr;
  return date.toLocaleString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
}

function RetailLifePage() {
  // Example data (replace with real data as needed)
  const productDetails = {
    policyName: "Old Mutual Investment Plan",
    policyNumber: "INV-2025-001",
    status: "Active",
    totalPremiumPaid: 12000,
    modalPremium: 1000,
    premiumAmount: 2000,
    premiumFrequency: "Monthly",
    totalRedemption: 2500,
    startDate: "2025-07-07",
    endDate: "2028-07-07"
  };
  const beneficiaries = [
    {
      name: "John Doe",
      percentage: "50%",
      relationship: "Brother",
      dob: "1990-05-10"
    },
    {
      name: "Jane Smith",
      percentage: "50%",
      relationship: "Sister",
      dob: "1992-08-15"
    }
  ];
  return (
    <div style={{ minHeight: '80vh', background: '#f5f6fa', padding: 24, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 32 }}>
      <div style={{ width: '100%', maxWidth: 700, display: 'flex', flexDirection: 'column', gap: 24, alignItems: 'center' }}>
        {/* Product Details Card */}
        <div style={{ background: '#fff', borderRadius: 18, boxShadow: '0 4px 24px 0 rgba(0,0,0,0.10)', padding: '32px 48px', width: '100%', display: 'flex', flexDirection: 'column', gap: 0, maxWidth: 700 }}>
          <div style={{ fontWeight: 800, fontSize: 20, color: '#000000ff', marginBottom: 12 }}>Product Details</div>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <div style={{ padding: '10px 0', textAlign: 'left' }}>
              <div style={{ color: '#444', fontWeight: 700, fontSize: 18 }}>{productDetails.policyName}</div>
              <div style={{ color: '#888', fontWeight: 500, fontSize: 13, marginTop: 2 }}>Policy Name</div>
            </div>
            <div style={{ borderTop: '1px solid #eee', padding: '10px 0', textAlign: 'left' }}>
              <div style={{ color: '#444', fontWeight: 700, fontSize: 18 }}>{productDetails.policyNumber}</div>
              <div style={{ color: '#888', fontWeight: 500, fontSize: 13, marginTop: 2 }}>Policy Number</div>
            </div>
            <div style={{ borderTop: '1px solid #eee', padding: '10px 0', textAlign: 'left', position: 'relative' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <span style={{ color: '#000000ff', fontWeight: 700, fontSize: 18 }}>{productDetails.status}</span>
                <InfoTooltip info={
                  productDetails.status === 'Active'
                    ? 'This policy is currently active and in good standing.'
                    : productDetails.status === 'Inactive'
                      ? 'This policy is not currently active.'
                      : 'Status information about this policy.'
                } />
              </div>
              <div style={{ color: '#888', fontWeight: 500, fontSize: 13, marginTop: 2 }}>Policy Status</div>
            </div>
            <div style={{ borderTop: '1px solid #eee', padding: '10px 0', textAlign: 'left' }}>
              <div style={{ color: '#444', fontWeight: 700, fontSize: 18 }}>{formatCurrency(productDetails.totalPremiumPaid)}</div>
              <div style={{ color: '#888', fontWeight: 500, fontSize: 13, marginTop: 2 }}>Total Premium Paid</div>
            </div>
            <div style={{ borderTop: '1px solid #eee', padding: '10px 0', textAlign: 'left' }}>
              <div style={{ color: '#444', fontWeight: 700, fontSize: 18 }}>{formatCurrency(productDetails.modalPremium)}</div>
              <div style={{ color: '#888', fontWeight: 500, fontSize: 13, marginTop: 2 }}>Modal Premium</div>
            </div>
            <div style={{ borderTop: '1px solid #eee', padding: '10px 0', textAlign: 'left' }}>
              <div style={{ color: '#444', fontWeight: 700, fontSize: 18 }}>{formatCurrency(productDetails.totalRedemption)}</div>
              <div style={{ color: '#888', fontWeight: 500, fontSize: 13, marginTop: 2 }}>Total Redemption</div>
            </div>
            {/* Premium Amount Row */}
            <div style={{ borderTop: '1px solid #eee', padding: '10px 0', textAlign: 'left' }}>
              <div style={{ color: '#444', fontWeight: 700, fontSize: 18 }}>{formatCurrency(productDetails.premiumAmount)}</div>
              <div style={{ color: '#888', fontWeight: 500, fontSize: 13, marginTop: 2 }}>Premium Amount</div>
            </div>
            {/* Premium Frequency Row */}
            <div style={{ borderTop: '1px solid #eee', padding: '10px 0', textAlign: 'left' }}>
              <div style={{ color: '#444', fontWeight: 700, fontSize: 18 }}>{productDetails.premiumFrequency}</div>
              <div style={{ color: '#888', fontWeight: 500, fontSize: 13, marginTop: 2 }}>Premium Frequency</div>
            </div>
            <div style={{ borderTop: '1px solid #eee', padding: '10px 0', textAlign: 'left' }}>
              <div style={{ color: '#444', fontWeight: 700, fontSize: 18 }}>{formatDate(productDetails.startDate)}</div>
              <div style={{ color: '#888', fontWeight: 500, fontSize: 13, marginTop: 2 }}>Premium Start Date</div>
            </div>
            <div style={{ borderTop: '1px solid #eee', padding: '10px 0', textAlign: 'left' }}>
              <div style={{ color: '#444', fontWeight: 700, fontSize: 18 }}>{formatDate(productDetails.endDate)}</div>
              <div style={{ color: '#888', fontWeight: 500, fontSize: 13, marginTop: 2 }}>Premium End Date</div>
            </div>
          </div>
        </div>
        {/* Beneficiary Card */}
        <div style={{ background: '#fff', borderRadius: 18, boxShadow: '0 4px 24px 0 rgba(0,0,0,0.10)', padding: '32px 48px', width: '100%', display: 'flex', flexDirection: 'column', gap: 0, maxWidth: 700 }}>
          <div style={{ fontWeight: 800, fontSize: 20, color: '#000000ff', marginBottom: 12 }}>Beneficiaries</div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
            {beneficiaries.map((b, idx) => {
              const initials = b.name.split(' ').map(n => n[0]).join('').toUpperCase();
              return (
                <div
                  key={b.name}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    borderTop: idx !== 0 ? '1px solid #eee' : undefined,
                    padding: '18px 0',
                    textAlign: 'left',
                    position: 'relative',
                    transition: 'background 0.2s, border-radius 0.2s',
                    cursor: 'pointer',
                    borderRadius: 0,
                  }}
                  onMouseEnter={e => {
                    e.currentTarget.style.background = '#e6f9ed';
                    e.currentTarget.style.borderRadius = '12px';
                  }}
                  onMouseLeave={e => {
                    e.currentTarget.style.background = '';
                    e.currentTarget.style.borderRadius = '0';
                  }}
                >
                  {/* Profile left */}
                  <div style={{ width: 48, height: 48, borderRadius: '50%', background: '#111', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, color: '#fff', fontSize: 20, marginRight: 18, flexShrink: 0 }}>
                    {initials}
                  </div>
                  {/* Details center */}
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontWeight: 500, color: '#222', fontSize: 18, lineHeight: 1.2 }}>{b.name}</div>
                    <div style={{ color: '#888', fontWeight: 500, fontSize: 15, marginTop: 2 }}>{b.percentage} Split</div>
                    <div style={{ color: '#888', fontWeight: 500, fontSize: 15, marginTop: 2, display: 'flex', alignItems: 'center', gap: 18 }}>
                      <span>{b.relationship}</span>
                      <span style={{ fontSize: 17, fontWeight: 400, color: '#bbb' }}>-</span>
                      <span>{b.dob ? formatDate(b.dob) : ''}</span>
                    </div>
                  </div>
                  {/* Arrow right */}
                  <div style={{ marginLeft: 18, display: 'flex', alignItems: 'center', fontSize: 22, color: '#888' }}>
                    <RightOutlined />
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

export default RetailLifePage;